/* Aus zwei Ständen eines Spielers die Ereignisse ableiten, über die die
 * Vereinsleitung benachrichtigt werden soll.
 *
 * Reine Funktion. Verglichen wird der zuletzt GESPEICHERTE Stand mit dem
 * gerade gespeicherten — ausgelöst wird also erst nach erfolgreichem
 * Speichern, nie für ungespeicherte Eingaben (siehe PlayerPanel.vue, onSave).
 *
 * Es gibt pro Speichern höchstens EINE Meldung je Typ. Der Text nennt kein
 * Detail ("News: Visum"), zwei Meldungen desselben Typs wären also nicht
 * unterscheidbar und nur Lärm.
 *
 * Bekannte Grenze: Visa, Reisen und Einladungen tragen keine eigene Kennung.
 * Neu heißt deshalb "mehr Einträge als vorher", Statuswechsel eines Visums
 * wird pro Listenposition verglichen. Wird im selben Speichern ein Eintrag
 * gelöscht UND ein anderer angelegt, zählt das nicht als neu; in genau diesem
 * Fall kann außerdem ein Visum-Statuswechsel fälschlich gemeldet werden. Bei
 * einer Löschung ohne Neuanlage wird der Statuswechsel gar nicht geprüft.
 */

function list(v) {
  return Array.isArray(v) ? v : [];
}

/**
 * @param {object|null} before  zuletzt gespeicherter Stand; null bei einem
 *   neu angelegten Spieler (dann gibt es keine Ereignisse)
 * @param {object} after        soeben gespeicherter Stand
 * @returns {string[]} Typen aus NOTIFICATION_TYPES, ohne Doppelte
 */
export function diffPlayerEvents(before, after) {
  if (!before || !after) return [];
  const out = [];

  if (list(after.feed).length > list(before.feed).length) out.push('feed_new');

  const bv = list(before.visas);
  const av = list(after.visas);
  if (av.length > bv.length) out.push('visa_new');
  if (av.length >= bv.length && bv.some((v, i) => (v && v.status) !== (av[i] && av[i].status))) {
    out.push('visa_status');
  }

  const bt = list(before.trips);
  const at = list(after.trips);
  if (at.length > bt.length) out.push('trip_new');
  // Updates nur an bereits vorhandenen Reisen — eine neue Reise ist trip_new.
  if (bt.some((t, i) => at[i] && list(at[i].updates).length > list(t && t.updates).length)) {
    out.push('trial_update');
  }

  if (list(after.invitations).length > list(before.invitations).length) out.push('invitation_new');

  if (before.status !== after.status) out.push('status_change');

  return out;
}
